import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { childrenRef } from "../../firebase";
import Add from "@material-ui/icons/Add";
import Kid from "./Kid";

import { AppBar, Toolbar, TextField } from "@material-ui/core";
import { light } from "../../../node_modules/@material-ui/core/styles/createPalette";
const styles = theme => ({
  title: {
    paddingLeft: "2%",
    paddingRight: "5%",
    paddingTop: "2%",
    paddingBottom: "5rem"
  },
  floatRight: {
    float: "right"
  },
  width100: {
    width: "100%"
  }
});

class Kids extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      displayData: [],
      loading: true
    };
  }

  componentWillMount() {
    const myId = this.props.myId;
    sessionStorage.setItem("kidsAvatar", []);
    childrenRef
      .where("parentId", "==", myId)
      .get()
      .then(querySnapshot => {
        let data = [];

        querySnapshot.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          let childData = {
            id: doc.id,
            data: doc.data()
          };
          data.push(childData);
        });

        let displayData = [...data];
        this.generateColor(displayData);

                this.setState({
                    displayData,
                    data,
                    loading: false
                });
            });
    }

  searchFilter = text => {
    let searchTerm = text.target.value;

        const { data } = this.state;

        let displayData = [];

        data.forEach(value => {
            let name = value.data.firstName + ' ' + value.data.lastName;

            console.log(name);

            if(name.toLocaleLowerCase().startsWith(searchTerm.toLocaleLowerCase())) {
                displayData.push(value);
            }
        });

    this.setState({ displayData });
  };
  generateColor(data) {
    if (!sessionStorage.getItem("kidsAvatar")) {
      let ColorArr = data.map(o => {
        return {
          kidid: o.id,
          color:
            "#" +
            Math.random()
              .toString(16)
              .substr(-6)
        };
      });
      sessionStorage.setItem("kidsAvatar", JSON.stringify(ColorArr));
    }

}
    render() {
        const { classes } = this.props;

        if( this.state.loading ) {
            return (
                <h2>Loading...</h2>
            );
        }

        if (this.state.data.length === 0) {
            return (
                <div className={classes.title}>
                    <h2>No kids added yet</h2>
          <Link to="/kids/add" style={{ textDecoration: "none" }}>
            <Button variant="outlined">
              {" "}
              ADD Kid <Add />
            </Button>
                    </Link>
                </div>
            );
        }

        return (
            <div className={classes.title}>

                    <div>
                        <TextField
                            value={this.state.searchText}
                            onChange={this.searchFilter}
                            style={{ paddingBottom: '10px', width: '100%' }}
                            label="Search"
                        />
                    </div>
        <AppBar position="static">
          <Toolbar>
            Kids
            <div className={classes.width100}>
              <Link to="/kids/add" style={{ textDecoration: "none" }}>
                <Button
                  color="secondary"
                  className={classes.floatRight}
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#FE008F"
                  }}
                  variant="outlined"
                >
                  ADD Kid <Add />
                </Button>
              </Link>
            </div>
          </Toolbar>
        </AppBar>
        {this.state.displayData.map(kid => {
          let colorObject = JSON.parse(sessionStorage.getItem("kidsAvatar"));

          let color = colorObject.find(o => o.kidid == kid.id);
          return (
            <Grid
              container
              key={kid.id}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Kid data={kid.data} id={kid.id} backgroundColor={color.color} />
            </Grid>
          );
        })}
      </div>
    );
  }
}

Kids.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Kids);




// WEBPACK FOOTER //
// ./src/components/Kids/Kids.js